module.exports = __webpack_public_path__ + "img/6-ocbc.93b3bdb0.jpg";